<template>
  <div class="goods_vat_summary">
    <div class="layout">
      <back-button class="back-button" caption="ย้อนกลับ" />
    </div>

    <div class="gvs-body">
      <div class="gvsb-title">
        <div class="gvsbt-wrapper">
          <h3 v-if="goodsType">ซื้อสินค้าแบบมี VAT</h3>
          <h3 v-else-if="!goodsType">ซื้อสินค้าแบบไม่มี VAT</h3>

          <div>เราคำนวณให้ว่า..</div>
        </div>
        <img :src="cartSVG" alt="cart" />
      </div>

      <div class="gvsb-table">
        <div class="gvsbt-row">
          <h4>รายละเอียด</h4>

          <div class="amount" @click="goCorpProfitEdit">
            <h4>
              จำนวนเงิน
            </h4>
            <img
              class="fbtcb-icon"
              src="@/assets/icons/bx_bxs-edit.svg"
              alt="phone-square"
            />
          </div>
        </div>
      </div>
      <div class="gvsb-table-background">
        <div class="gvsb-table-body">
          <div class="gvsbt-row">
            <div>รายได้จากการขายสินค้าต่อปี</div>
            <div class="gvsbtr-link">
              <currency
                mode="readOnly"
                v-model="vatInfo.sellingPriceExcludeVat"
              />
            </div>
          </div>
        </div>

        <div class="gvsb-table-body">
          <div class="gvsbt-row">
            <div>ภาษีขาย</div>
            <div>
              <currency mode="readOnly" v-model="vatInfo.sellingVat" />
            </div>
          </div>
        </div>

        <div class="gvsb-table-body">
          <div class="gvsbt-row">
            <div>{{ labelCost }}</div>
            <div class="gvsbtr-link">
              <currency
                mode="readOnly"
                v-model="vatInfo.purchasePriceExcludeVat"
              />
            </div>
          </div>
        </div>

        <div class="gvsb-table-body">
          <div class="gvsbt-row">
            <div>ภาษีซื้อ</div>
            <div>
              <currency mode="readOnly" v-model="vatInfo.purchaseVat" />
            </div>
          </div>
        </div>

        <div class="gvsb-table-body">
          <div class="gvsbt-row">
            <div>ภาษีนำส่ง</div>
            <div>
              <currency mode="readOnly" v-model="vatInfo.vat" />
            </div>
          </div>
        </div>

        <div class="gvsb-table-body">
          <div class="gvsbt-row">
            <div>ภาษีสิ้นปี</div>
            <div>
              <currency mode="readOnly" v-model="vatInfo.tax" />
            </div>
          </div>
        </div>

        <div class="gvsb-table-body">
          <div class="gvsbt-row">
            <div>เงินคงเหลือ</div>
            <div>
              <currency mode="readOnly" v-model="vatInfo.netCash" />
            </div>
          </div>
        </div>

        <div class="gvsb-table-body">
          <div class="gvsbt-row">
            <div>สภาพคล่องทางการเงิน</div>
            <h4>
              <currency mode="readOnly" v-model="vatInfo.cashFlow" />
            </h4>
          </div>
        </div>
      </div>

      <div class="gvsb-next">
        <div>
          <chevron-right-link
            @clickLink="goCorpDefinition"
            caption="ดูคำอธิบายเพิ่ม"
          />
        </div>
      </div>

      <material-button
        class="gvsb-button"
        @clickButton="$router.push('/forms/goods_vat_compare')"
      >
        เปรียบเทียบกับการซื้อของแบบ<span v-show="goodsType">ไม่</span>มี VAT
      </material-button>
    </div>
    <Tutorial />
  </div>
</template>

<script>
import SHOPPINGCARTCHECK from "@/assets/icons/Shopping Cart Check.svg";
import SHOPPINGCARTREMOVE from "@/assets/icons/Shopping Cart Remove.svg";

import Tutorial from "./Tutorial.vue";

export default {
  name: "GoodsVatSummary",
  components: {
    Tutorial,
  },
  data() {
    const goodsType = this.$store.getters["questions/getAnswers"].goodsType;
    const labelIncome = "(รวม VAT)";
    const labelCost = "ต้นทุนสินค้าต่อเดือน";

    let cartSVG = SHOPPINGCARTCHECK;
    cartSVG = goodsType ? SHOPPINGCARTCHECK : SHOPPINGCARTREMOVE;

    const tutorial = true;

    return {
      labelIncome,
      labelCost,
      goodsType,
      cartSVG,
      tutorial,
    };
  },
  methods: {
    goCorpDefinition() {
      this.$router.push({
        path: "/info/corp_vat_definition",
      });
    },
    goCorpProfitEdit() {
      this.$router.push({
        path: "/forms/corp_profit_edit",
      });
    },
  },
  computed: {
    vatInfo() {
      let vatInfo = null;
      const taxType = this.$store.getters["questions/getAnswers"].taxType;

      const withoutVatInfo =
        taxType === "personal"
          ? this.$store.getters["vatCompare/getPersonalWithoutVatInfo"]
          : this.$store.getters["vatCompare/getCorporateWithoutVatInfo"];

      const withVatInfo =
        taxType === "personal"
          ? this.$store.getters["vatCompare/getPersonalWithVatInfo"]
          : this.$store.getters["vatCompare/getCorporateWithVatInfo"];

      vatInfo = this.goodsType ? withVatInfo : withoutVatInfo;
      return vatInfo;
    },
  },
};
</script>

<style scoped>
.goods_vat_summary {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  position: relative;
}
.layout {
  width: 100%;
  padding: 0px 30px;
  max-width: 1120px;
  box-sizing: border-box;
}
.gvs-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 544px;
  text-align: center;
  position: relative;
  /* margin-top: 34px; */
  margin-bottom: 40px;
}
.gvsb-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 16px;
  text-align: left;

  padding: 0px 30px;
  box-sizing: border-box;
}

.gvsb-table {
  width: 100%;
  background: #29a9e2;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.gvsbt-row {
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  white-space: nowrap;
  padding: 0px 30px;
  box-sizing: border-box;
}
.amount {
  display: flex;
  align-items: center;
  width: 150px;
  justify-content: flex-end;
  cursor: pointer;
}

.amount h4 {
  margin-right: 4px;
}
.gvsb-table-background {
  width: 100%;
}
.gvsb-table-background > div:nth-child(even) {
  background: rgba(41, 169, 226, 0.05);
}
.gvsb-table-body {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.gvsb-next {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;

  margin-top: 16px;
  padding: 0px 30px;
  box-sizing: border-box;
}

.gvsb-button {
  max-width: 352px;
  margin-top: 32px;
}

.back-button {
  margin: 24px 0;
}
.gvsbt-row > div {
  text-align: left;
}
/*size  >768px */
@media only screen and (min-width: 769px) {
  .layout {
    padding: 0 20px;
  }
  .back-button {
    margin-bottom: 0;
  }
}
</style>
